const modifyScriptName = (tradingsymbol, expiryDate) => {
  // Extract the base symbol name (everything before the date part)
  const baseSymbol = tradingsymbol.split(/\d/)[0];

  // If no expiry date is provided, fall back to the original behavior
  if (!expiryDate) {
    return `${tradingsymbol.slice(0, -8)} ${tradingsymbol.slice(-6, -5)}${tradingsymbol.slice(-5, -3).toLowerCase()}`;
  }

  // Parse the expiry date
  try {
    const expiry = new Date(expiryDate);

    // Format day with leading zero if needed
    const day = expiry.getDate().toString().padStart(2, '0');

    // Get month name in uppercase
    const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const month = monthNames[expiry.getMonth()];

    // Get year - optional, can be used for long-term contracts
    const year = expiry.getFullYear().toString().substr(2, 2); // Last 2 digits of year

    // Format based on expiry date - for current year contracts just show day and month
    // For future year contracts, include the year
    const currentYear = new Date().getFullYear();
    const formattedDate = expiry.getFullYear() === currentYear
      ? `${day} ${month}`
      : `${day}-${month}-${year}`;

    // Return formatted string: "ALUMINIUM 30-MAY" or "ALUMINIUM 30-MAY-24"
    return `${baseSymbol.trim()} ${formattedDate}`;
  } catch (error) {
    console.error('Error parsing expiry date:', error);
    // Fallback to original behavior if date parsing fails
    return `${tradingsymbol.slice(0, -8)} ${tradingsymbol.slice(-6, -5)}${tradingsymbol.slice(-5, -3).toLowerCase()}`;
  }
};

export const calculateActiveProfitLoss = (activeTrades, priceConfig) => {
  try {
    // Initialize overall profit or loss
    let overallProfitLoss = 0;
    let blockedMargin = 0;
    // console.log('ACTIVE TRADE', activeTrades);

    // Iterate through each active trade
    activeTrades.forEach((trade) => {
      let multiplicationFactor = 1;
      // Get the buy price and sell price based on the side of the trade
      if (trade.script.exchange.name === 'MCX' || trade.script.exchange.name === 'COMEX') {
        const scriptName = trade.script.name;
        const factor = priceConfig[trade.script.exchange.name][scriptName] || 1;
        multiplicationFactor = factor;
      }
      const price = trade.side === 'BUY' ? trade.script?.depth?.buy[0].price : trade.script?.depth?.sell[0].price;
      // Calculate profit or loss for the trade
      const tradeProfitLoss =
        trade.side === 'BUY'
          ? (price - trade.buy) * multiplicationFactor * trade.quantity
          : (trade.sell - price) * multiplicationFactor * trade.quantity;
      // console.log(tradeProfitLoss);
      // Add the trade profit or loss to the overall profit or loss
      overallProfitLoss += tradeProfitLoss;
      blockedMargin += trade.margin;
    });
    return { overallProfitLoss, blockedMargin };
  } catch (error) {
    console.error('Error calculating overall profit or loss:', error);
    throw error;
  }
};

export default modifyScriptName;
